import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PushNotificationService } from '@core/services';
import { PushNotificationModalComponent } from '@ui/push-notification/push-notification-modal.component';
import { environment } from '../environments/environment';
import { UserService } from '@core/auth/services/user.service';
import { UserMeModel } from '@core/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'sir-rent';

  private notificationSubscription: Subscription | null = null;
  private routerSubscription: Subscription | null = null;
  private isModalOpen = false;
  private isOnAuthPage = false;

  constructor(
    private pushNotificationService: PushNotificationService,
    private dialog: MatDialog,
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.checkCurrentRoute();

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkCurrentRoute();
      });

    setTimeout(() => {
      this.pushNotificationService.start();

      this.notificationSubscription = this.pushNotificationService.notification$
        .subscribe(() => {
          this.showPushNotification();
        });
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }

    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    
    this.pushNotificationService.stop();
  }

  private checkCurrentRoute(): void {
    const url = this.router.url;
    this.isOnAuthPage = url.startsWith('/auth');
  }

  private showPushNotification(): void {
    try {
      if (this.isOnAuthPage) {
        return;
      }

      const currentUser = this.userService.currentUserValue;
      if (currentUser && currentUser.role !== UserMeModel.RoleEnum.USER) {
        return;
      }

      if (this.isModalOpen) {
        return;
      }

      if (this.pushNotificationService.isInstalledAsPWA()) {
        return;
      }

      if (this.pushNotificationService.isDismissed()) {
        return;
      }

      this.isModalOpen = true;

      const dialogRef = this.dialog.open(PushNotificationModalComponent, {
        width: '580px',
        maxWidth: 'calc(100vw - 32px)',
        disableClose: false,
        autoFocus: false,
        data: {
          instructionUrlAndroid: environment.appInstallationInstructionUrlAndroid,
          instructionUrlIOS: environment.appInstallationInstructionUrlIOS
        }
      });

      dialogRef.afterClosed().subscribe(() => {
        this.isModalOpen = false;
      });
    } catch (error) {
      console.error('Error showing push notification:', error);
      this.isModalOpen = false;
    }
  }
}
